window.owlCarouselConf = {
  margin: 0,
  loop: true,
  center: true,
  autoplay: true,
  autoplayTimeout: 5500,
  autoplayHoverPause: true,
  fluidSpeed: true,
  autoplaySpeed: 5000,
  dots: true,
  nav: true,
  navText: [
    '<svg class="left font-icon"><use xlink:href="#caret" href="#caret"></use></svg>',
    '<svg class="right font-icon"><use xlink:href="#caret" href="#caret"></use></svg>',
  ],
  responsive: {
    0: {
      items: 1,
    },
    540: {
      items: 1.5,
    },
    768: {
      items: 3,
    },
    1024: {
      items: 4,
    },
  },
};

(function ($) {
  // Autoplay does not start after the mouse leaves the carousel, so play it again
  $(document).on('mouseleave', '.owl-carousel', function () {
    var carousel = $(this).data('owl.carousel');
    if (
      !carousel ||
      !carousel.settings ||
      !carousel.settings.autoplay ||
      !carousel.settings.autoplayHoverPause
    ) {
      return;
    }

    $(this).trigger('stop.owl.autoplay');
    $(this).trigger('play.owl.autoplay');
  });
}).bind(window)(jQuery);
